import BannerList from "../../components/banner/bannerLists.comp";
import AddLink from "../../components/form/addLink.comp";
import Layout from "../../components/layouts/layout.comp";
import { useTranslation } from "../../core/translation.core";

export default function MediaPage() {
  const { t, msg } = useTranslation();

  return (
    <Layout
      title={t(msg.banner.banner)}
      breadcrumbs={[{ name: t(msg.banner.banner), link: "/banner" }]}
      titleBtn={<AddLink id="banner-create" href="/banner/create" />}
    >
      <BannerList />
    </Layout>
  );
}
